import RequirementsCardLTR from '../../../../../pages/vip/features/requirements-card-ltr/requirements-card-ltr.desktop';

export default RequirementsCardLTR;
